/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Key_Command_LabelInputs */

const en_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Command`)
};

const fr_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande`)
};

const de_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastenkombination`)
};

const it_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando chiave`)
};

const ru_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключевая команда`)
};

const es_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando de teclado`)
};

const zh_cn2_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按键命令`)
};

const ja_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーコマンド`)
};

const hi_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य कमांड`)
};

const pt_pt2_shortcut_keys_key_command_label = /** @type {(inputs: Shortcut_Keys_Key_Command_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comando de tecla`)
};

/**
* | output |
* | --- |
* | "Key Command" |
*
* @param {Shortcut_Keys_Key_Command_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_key_command_label = /** @type {((inputs?: Shortcut_Keys_Key_Command_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Key_Command_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_key_command_label(inputs)
	if (locale === "de") return de_shortcut_keys_key_command_label(inputs)
	if (locale === "it") return it_shortcut_keys_key_command_label(inputs)
	if (locale === "ru") return ru_shortcut_keys_key_command_label(inputs)
	if (locale === "es") return es_shortcut_keys_key_command_label(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_key_command_label(inputs)
	if (locale === "ja") return ja_shortcut_keys_key_command_label(inputs)
	if (locale === "hi") return hi_shortcut_keys_key_command_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_key_command_label(inputs)
	return en_shortcut_keys_key_command_label(inputs)
});